import { schools as schoolsServices } from '@coligo-org/fe-common/services';

import logger from 'common/services/logService';
import { ErrorsActions } from '../../../../../common/error/state';
import Types from '../types';

export const createItemStart = () => ({
  type: Types.CREATE_ITEM_START,
});

export const createItemEnd = () => ({
  type: Types.CREATE_ITEM_END,
});

export default ({ schoolId, data, callback }) =>
  async dispatch => {
    try {
      dispatch(createItemStart());
      await schoolsServices.createCourseTemplate({ schoolId, data });
      if (callback) callback();
    } catch (error) {
      logger.log(error);
      if (error.response) {
        dispatch(ErrorsActions.addError(error.response.data.message));
      }
    } finally {
      dispatch(createItemEnd());
    }
  };
